<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                <!--div class="m-form-item-wrapper">
                  <label for="kategori">Type</label>
                  <a-select
                    placeholder="Select Type"
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in typeKategori"
                      :key="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div-->
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Select Status"
                    v-model="status"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option :key="'not closed'">Not Closed</a-select-option>
                    <a-select-option :key="'closed'">Closed</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot
       
        :loading="loading"
        title="Receivables Employee List"
        createLink="piutangkaryawan-create-keu"
        manifestLink="piutangkaryawan-manifest-keu"
        editLink="piutangkaryawan-edit-keu"
        draftEditLink=""
        :dataList="searching"
        :price="false"
        :allowcancel="false"
        :disabledCreateEditLink="!allowCreate"
      >
        <div slot="status" slot-scope="data" >
        
                     
          <status :status="data.item.status"  />
         
        </div>
      </DataListSlot>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListPiutangKaryawan",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      installmentList: [],
      kategori: undefined,
      searchDate: null,
      search: "",
      status: undefined,
      allowCreate: this.$route.meta.ishrd,
      filter: {
        type: undefined,
      },
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("callbackTab", this.clickTabed);

    if(!this.isHRD){
      this.allowCreate = false;
    }
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("callbackTab", this.clickTabed);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getDefaultDateFormat",
    ]),
    searching() {
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
         (obj) =>
            (obj.searchQ !== null ? obj.searchQ.toLowerCase() : "").indexOf(
              this.search.toLowerCase()
            ) >= 0
        );
      }

     if (this.searchDate) {
        let filter = moment(this.searchDate).format(
          'DD-MM-YYYY'
        );
        output = _.filter(output, (obj) => 
          moment(obj.tanggal,'DD-MM-YYYY').format('DD-MM-YYYY') == filter);
      }

       if (this.status) {
        output = _.filter(output, (obj) => 
          obj.status.toLowerCase() == this.status);
      }

      return output;
    },
    isHRD(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='hrd'){
          res = true
        }
      });
      return res
    },
  },
  methods: {
    moment,
    fetchData() {
      const laporan = axios({
        method: "get",
        url: this.$serviceUrl + "Piutang_karyawan",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          laporan.catch(() => {
            return null;
          }),
        ])
       
        .then((response) => {
         //console.log(response[0].data.data);
            response[0].data.data.forEach((data) => {
              this.dataList.push({
                title: data.piutang_karyawan_no,
                searchQ:
                  data.piutang_karyawan_no + " " +
                  data.description + " " +
                  data.tlc_create + " " +
                  moment(data.create_dt).format(
                    this.getDefaultDateFormat) + " " +
                  data.type + " " +
                  data.end_user,

               subdesc: [
                  data.tlc_create + " | " + moment(data.create_dt).format(
                        this.getDefaultDateFormat
                      ),
                  data.description,
                   
                  [
                    {
                      label: "End User",
                      value: data.end_user,
                    },
                  ],
                  [
                    {
                      label: "Installment amount",
                      value: data.installment_amount + ( data.installment_amount ? " x Installment" : ""),
                    },
                  ],
                  [
                    {
                      label: "Installment Value",
                      value:this.formatCurrency('IDR',data.installment_value),
                    },
                  ],
                  [
                    {
                      label: "Value",
                      value: this.formatCurrency('IDR',data.value)
                    },
                  ],
                  [
                    {
                      label: "Down Payment",
                      value: this.formatCurrency('IDR',data.dp ? data.dp : 0)
                    },
                  ],
                  [
                    {
                      label: "Remaining balance",
                      value: this.formatCurrency('IDR',data.remaining_balance)
                    },
                  ],
                  
                ],
                 
                status: data.close_sts,
                //cancelStatus: data.status_besar=='Canceled' ? data.status_besar: null,
                tanggal: moment(data.create_dt).format(
                  this.getDefaultDateFormat
                ),
                type : data.type,
                unread: true,
                id: data.piutang_karyawan_id,                
              });
            });

         
          this.loading = false;
         
        })
        .catch(() => {
          this.loading = false;
        });
    },
   
    
  },
};
</script>

<style>
</style>